module.exports = __webpack_public_path__ + "img/Netherlands.9a434a63.svg";